import { setShowSubcontractorModal } from '../State/showSubcontractorModal';
import fetchSubcontractor from '../Services/fetchSubcontractor';

export default () => async (dispatch) => {
  
  dispatch(fetchSubcontractor());
  dispatch(setShowSubcontractorModal(false));
  
  
}